import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Sprig from "./Sprig";
import { useLang } from "../i18n/LanguageContext";
import logoWhite from "../assets/mainLogo.png";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <Wrap>
      <Cta>
        <img src={logoWhite} />
        <h2>{t("footer.title")}</h2>
        <p>{t("footer.subtitle")}</p>
        <Btn to="/list">{t("footer.cta")}</Btn>
        <ManageLink to="/manage">{t("footer.manage")}</ManageLink>
      </Cta>

      <Bottom>
        <img src={logoWhite} alt="Amora Weddings" />
        <Tagline>{t("footer.tagline")}</Tagline>
        <Links>
          <Link to="/about">{t("footer.about")}</Link>
          <Link to="/faq">{t("footer.faq")}</Link>
          <Link to="/contact">{t("footer.contact")}</Link>
          <Link to="/terms">{t("footer.terms")}</Link>
          <Link to="/privacy">{t("footer.privacy")}</Link>
        </Links>
        <Copy>
          © {year} Amora Weddings. {t("footer.rights")}
        </Copy>
      </Bottom>
    </Wrap>
  );
}

const Wrap = styled.footer`
  background: ${({ theme }) => theme.colors.greenDeep};
  color: ${({ theme }) => theme.colors.cream};
  padding: clamp(50px, 8vw, 80px) clamp(20px, 5vw, 64px) 40px;
`;

const Cta = styled.div`
  text-align: center;
  img {
    width: 90px;
  }
  h2 {
    font-family: ${({ theme }) => theme.font.display};
    font-weight: 500;
    font-size: clamp(26px, 4vw, 40px);
    line-height: 1.1;
  }
  p {
    margin: 16px auto 0;
    max-width: 480px;
    color: rgba(251, 247, 239, 0.7);
    font-size: 15px;
  }
`;

const Btn = styled(Link)`
  margin-top: 30px;
  display: inline-block;
  background: ${({ theme }) => theme.colors.cream};
  color: ${({ theme }) => theme.colors.greenDeep};
  font-weight: 600;
  font-size: 15px;
  padding: 15px 32px;
  border-radius: 100px;
  transition: 0.25s;
  &:hover {
    background: #fff;
    transform: translateY(-2px);
  }
`;

const ManageLink = styled(Link)`
  display: block;
  margin-top: 16px;
  font-size: 13px;
  color: rgba(251, 247, 239, 0.7);
  text-decoration: underline;
  &:hover {
    color: ${({ theme }) => theme.colors.cream};
  }
`;

const Bottom = styled.div`
  margin-top: clamp(40px, 7vw, 64px);
  padding-top: 32px;
  border-top: 1px solid rgba(251, 247, 239, 0.14);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  img {
    height: 26px;
    width: auto;
    opacity: 0.9;
  }
`;

const Tagline = styled.p`
  margin-top: -6px;
  font-size: 14px;
  color: rgba(251, 247, 239, 0.65);
  font-style: italic;
`;

const Links = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px 26px;
  a {
    font-size: 13.5px;
    color: rgba(251, 247, 239, 0.7);
    &:hover {
      color: ${({ theme }) => theme.colors.cream};
    }
  }
`;

const Copy = styled.div`
  font-size: 12px;
  color: rgba(251, 247, 239, 0.45);
  text-align: center;
`;
